
















import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';

@Component
export default class Alert extends Vue {
  @Prop() private readonly message: string;
  @Prop() private readonly type: string;
  @Prop({ default: 'warning '}) private readonly icon: string;

  get classType() {
    switch (this.type) {
      case 'warning':
        return 'is-warning';
      default:
        return '';
    }
  }

  private get visible(): boolean {
    return this.message !== '';
  }

}
